import { render } from "./TransactionSelection.vue?vue&type=template&id=5355ad0d&scoped=true"
import script from "./TransactionSelection.vue?vue&type=script&lang=js"
export * from "./TransactionSelection.vue?vue&type=script&lang=js"

import "./TransactionSelection.vue?vue&type=style&index=0&id=5355ad0d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5355ad0d"]])

export default __exports__